import { render, staticRenderFns } from "./Carts.vue?vue&type=template&id=7bb98b20&scoped=true"
import script from "./Carts.vue?vue&type=script&lang=js"
export * from "./Carts.vue?vue&type=script&lang=js"
import style0 from "./Carts.vue?vue&type=style&index=0&id=7bb98b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb98b20",
  null
  
)

export default component.exports